module.exports = __webpack_public_path__ + "static/img/banner2.23d8a847.png";